import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'rd-tabs',
  template: `<div *ngIf="display" class="tabContainer">
  <ng-content></ng-content>
</div>
`,
  styles: [`.tabContainer{max-width:100%;word-wrap:break-word}`]
})
export class RDTabsComponent implements OnInit {

  @Input() title = '';

  @Output() changeDisplay: EventEmitter<any> = new EventEmitter();

  public display = false;

  constructor() { }

  ngOnInit() {
  }

}
